import { BaseRHFWidgetProps } from "@impero-com/common/components/form/rhfFields/types";
import { FieldValues, useController } from "react-hook-form";

import {
    UserTypeaheadInput,
    UserTypeheadInputBaseProps,
} from "../fields/userTypeaheadInput";

type UserId = number;
type ValueType = UserId | undefined | null;
interface RHFUserTypeaheadInputProps<TFieldsValues extends FieldValues>
    extends
        BaseRHFWidgetProps<TFieldsValues, ValueType>,
        UserTypeheadInputBaseProps {
    onChange?: (newValue: number) => void;
}

export function RHFUserTypeaheadInput<TFieldsValues extends FieldValues>({
    name,
    control,
    filter,
    helpText,
    placeholder,
    label,
    disabled,
    allowClear,
    onRemove,
    removeDisabled,
    onChange,
}: RHFUserTypeaheadInputProps<TFieldsValues>) {
    const { field, fieldState } = useController({ name, control, disabled });
    return (
        <UserTypeaheadInput
            value={field.value}
            error={fieldState.error?.message}
            onChange={(value) => {
                field.onChange(value);
                onChange?.(value);
            }}
            onBlur={field.onBlur}
            fieldRef={field.ref}
            disabled={field.disabled}
            filter={filter}
            helpText={helpText}
            placeholder={placeholder}
            label={label}
            allowClear={allowClear}
            onRemove={onRemove}
            removeDisabled={removeDisabled}
        />
    );
}
